const GenerateSidebar = ({
  children,
  onClickedOutside,
}: {
  children: React.ReactNode;
  onClickedOutside?: () => void;
}) => (
  <div className="mx-auto left-0 mobile:left-auto right-0 z-10 large:desktop:z-0 top-32 mobile:mr-4">
    <div
      onClick={onClickedOutside}
      className={`backdrop-brightness-50 h-screen w-screen mobile:h-auto mobile:w-auto fixed top-0`}
    />
    <div
      className={`mx-auto w-fit px-1 mobile:w-full absolute mobile:static bg-panel-middleground mt-16 mobile:mt-0 p-1 rounded-xl left-0 right-0 box_drop_shadow`}
    >
      <div className="relative flex flex-col p-6 my-auto bg-panel-background rounded-xl">
        {children}
      </div>
    </div>
  </div>
);
export default GenerateSidebar;
